module.exports = ".client-section {\n  cursor: pointer; }\n  .client-section p,\n  .client-section h4,\n  .client-section hr {\n    margin-bottom: 0; }\n  .client-section span {\n    cursor: default; }\n  .client-section h4 > span {\n    word-break: break-word; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/job-client/job-client.scss
// module id = ./web/modern/components/client/job-client/job-client.scss
// module chunks = 0